module.exports = __webpack_public_path__ + "img/footer-ph3.1448c25c.png";